import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaRegCopy } from "react-icons/fa";
import "../../styles/thankyou.css";

const DEFAULTS = {
    title: "Thank You!",
    message:
        "Your request has been received successfully. Our team will get in touch with you shortly.",
    referenceId: null,
    details: [], // [{ label: "Booking Date", value: "15 Aug 2026" }]
    primaryCta: { label: "Back to Home", to: "/" },
    secondaryCta: null, // { label: "Book Another Kirtan", to: "/kirtan" }
};

export default function ThankYou() {
    const location = useLocation();
    const data = { ...DEFAULTS, ...(location.state || {}) };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const copyRef = () => {
        if (data.referenceId) {
            navigator.clipboard.writeText(data.referenceId);
        }
    };

    return (
        <section className="ikty-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-9 col-lg-7">
                        <div className="ikty-card text-center">
                            <div className="ikty-icon-wrap">
                                <IoCheckmarkCircle className="ikty-icon" />
                            </div>

                            <h1 className="ikty-title">{data.title}</h1>
                            <p className="ikty-message">{data.message}</p>

                            {data.referenceId && (
                                <div className="ikty-ref d-inline-flex align-items-center gap-2">
                                    <span className="ikty-ref-label">Reference ID</span>
                                    <span className="ikty-ref-value">{data.referenceId}</span>
                                    <button
                                        type="button"
                                        className="ikty-copy-btn"
                                        onClick={copyRef}
                                        aria-label="Copy reference ID"
                                    >
                                        <FaRegCopy />
                                    </button>
                                </div>
                            )}

                            {data.details?.length > 0 && (
                                <div className="ikty-details">
                                    {data.details.map((d, i) => (
                                        <div className="ikty-detail-row" key={i}>
                                            <span className="ikty-detail-label">{d.label}</span>
                                            <span className="ikty-detail-value">{d.value}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className="ikty-actions d-flex flex-wrap justify-content-center gap-3">
                                {data.secondaryCta && (
                                    <Link to={data.secondaryCta.to} className="ikty-btn ikty-btn-outline">
                                        {data.secondaryCta.label}
                                    </Link>
                                )}
                                <Link to={data.primaryCta.to} className="ikty-btn ikty-btn-solid">
                                    {data.primaryCta.label}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}